angular.module('iqxCore')
.controller('iqxDatePickerCtrl', function ($timeout) {
	var $ctrl = this; $ctrl.startWeekOnSunday = false; $ctrl.datePicker = {} // initialize $ctrl and datePickerObject and startWeekOnSunday
	$ctrl.$onInit = function(){  setAccuracy(); setDisplayTitle()  } // set accuracy (to default if not provided), set input text (placeholder if no moment, default placeholder if no placeholder)
	$ctrl.$doCheck = function(){  setDisplayTitle()  } // update text on each digest cycle to ensure it is correct
	$ctrl.$onDestroy = function(){  document.querySelector("body").classList.remove("date-picker-open"); window.removeEventListener('resize', $ctrl.closeDatePicker)  } // event listener off, scroll on

	function setDisplayTitle(){
		if(moment.isMoment($ctrl.iqxDate)){
			if(  $ctrl.datePicker.accuracy==="time"  ){  $ctrl.display = $ctrl.iqxDate.format('DD/MM/YYYY HH:mm')  }
			else if(  $ctrl.datePicker.accuracy==="day"  ){  $ctrl.display = $ctrl.iqxDate.format('dddd D MMMM YYYY')  }
			else if(  $ctrl.datePicker.accuracy==="month"  ){  $ctrl.display = $ctrl.iqxDate.format('MMMM YYYY')  }
			else if(  $ctrl.datePicker.accuracy==="year"  ){  $ctrl.display = $ctrl.iqxDate.format('YYYY')  }
		}
		else if(  $ctrl.placeholder  ){  $ctrl.display = $ctrl.placeholder  }
		else if(  $ctrl.datePicker.accuracy==="time"  ){  $ctrl.display = "Select date and time" }
		else if(  $ctrl.datePicker.accuracy==="day"  ){  $ctrl.display = "Select date" }
		else if(  $ctrl.datePicker.accuracy==="month"  ){  $ctrl.display = "Select month" }
		else if(  $ctrl.datePicker.accuracy==="year"  ){  $ctrl.display = "Select year" }
	}

	function setAccuracy(){  // defaulting to day if not specified, or value is invalid
		if(  !$ctrl.accuracy || ($ctrl.accuracy!=='time' && $ctrl.accuracy!=='day' && $ctrl.accuracy!=='month' && $ctrl.accuracy!=='year')  ){  $ctrl.datePicker.accuracy='day'  }
		else{  $ctrl.datePicker.accuracy=$ctrl.accuracy  }
	}

	$ctrl.checkRangeIfDisabled = function(momentObj, type){ // returns true if entire day/year/..  is disabled
		if(type==="twentyYears"){ // special case for year select view which has 20 years on it...
			var numToRemove = momentObj.year() % 20 // figure out how much we need to take away to get a multiple of twenty
			var firstYearOnYearView = momentObj.clone().subtract(numToRemove, "years").startOf("year"), lastYearOnYearView = firstYearOnYearView.clone().add(19, "years").endOf("year")
			if(  firstYearOnYearView.isAfter($ctrl.datePicker.max)  ){  return true  }
			if(  lastYearOnYearView.isBefore($ctrl.datePicker.min)  ){  return true  }
		}
		else if(  momentObj.clone().startOf(type).isAfter($ctrl.datePicker.max)  ){  return true  }
		else if(  momentObj.clone().endOf(type).isBefore($ctrl.datePicker.min)  ){  return true  }
		return false
	}

	$ctrl.openDatePicker = function(e){ // function to open date picker
    if($ctrl.iqxDisabled){return} // date picker is disabled so you are not allowed to open it
		setAccuracy()  // call set accuracy to update it if it has changed for some reason
		var e = e  // create refrence to event object
		if(  $ctrl.datePicker.show  ){  $ctrl.closeDatePicker(); return  } // if date picker is already open, close it
		// set datepicker min and max moments (defaults min -100 and max +10 years)
		if(  moment.isMoment($ctrl.min)  ){  $ctrl.datePicker.min = $ctrl.min.clone()  } else {  $ctrl.datePicker.min = moment().subtract(100, "years")  }
		if(  moment.isMoment($ctrl.max)  ){  $ctrl.datePicker.max = $ctrl.max.clone()  } else {  $ctrl.datePicker.max = moment().add(10, "years")  }
		// log error if min moment is after max moment (and dont open date picker)
		if(  $ctrl.datePicker.min.isAfter($ctrl.datePicker.max)  ){  console.error("iqxDatePicker - min date is after max date, there are no valid moments!"); return  }
		// set newMoment to model if it is valid, else set it to now
		if(  moment.isMoment($ctrl.iqxDate)  ){  $ctrl.newMoment = $ctrl.iqxDate.clone()  } else {  $ctrl.newMoment = moment()  }
		$ctrl.datePicker.disableTodayBtn = $ctrl.checkRangeIfDisabled(moment(), 'day') // check if 'today' could be a valid date.
		calcDatePickerPositions(e) // set positions for date picker
		window.addEventListener('resize', $ctrl.closeDatePicker)  // add event listener to close date picker on window resize
		// open view for date picker (dependion on what accuracy is set)
		if(  $ctrl.datePicker.accuracy=="day" || $ctrl.datePicker.accuracy=="time"  ){  $ctrl.daySelectView()  }
		else if(  $ctrl.datePicker.accuracy=="month"  ){  $ctrl.monthSelectView()  }
		else if(  $ctrl.datePicker.accuracy=="year"  ){  $ctrl.yearSelectView()  }

	}

	function calcDatePickerPositions(e){ // function to figure out where date picker should be positioned on page and if it should be inline or modal mode.
		$ctrl.datePicker.styles = {}
		if(window.innerWidth <= 767 && $ctrl.datePicker.mode !== "modal"){
			$ctrl.datePicker.mode = "modal" // set datepicker mode to modal
			// set left and top values for position
			$ctrl.datePicker.styles.left = 2 + "%"; $ctrl.datePicker.styles.top = 2 + "%"
			document.querySelector("body").classList.add("date-picker-open") // disable scrolling
		}else if($ctrl.datePicker.mode !== "inline"){
			//  inline desktop mode
			var positionObj = e.currentTarget.getBoundingClientRect()
			$ctrl.datePicker.mode = "inline" // set datepicker mode to inline
			// set left and top values for position
			$ctrl.datePicker.styles.left = e.currentTarget.offsetLeft + "px"; $ctrl.datePicker.styles.top = e.currentTarget.offsetTop + e.currentTarget.offsetHeight  + "px"
			document.querySelector("body").classList.remove("date-picker-open") // enable scrolling
		}
	}

	$ctrl.closeDatePicker = function(){
		$timeout(function(){ // the timeout here is needed! otherwise it closes but dosent close... 
			$ctrl.datePicker.show = false
			$ctrl.datePicker.mode = "" // to ensure if figures its self out correctly next time it is opened
			document.querySelector("body").classList.remove("date-picker-open") // ensure that scrolling is enabled
			$ctrl.datePicker.view = ""
			window.removeEventListener('resize', $ctrl.closeDatePicker)
		})
	}

	$ctrl.clear = function(){
		$ctrl.iqxDate = null
		$ctrl.closeDatePicker()
	}

	$ctrl.setToToday = function(){ // if accuracy is time then show time picker with date today, else just set iqxDate to today and close date picker
		if($ctrl.checkRangeIfDisabled(moment(), "day")){return false}
		if($ctrl.accuracy==="time"){  $ctrl.newMoment = moment(); $ctrl.timeSelectView()  }
		else{  $ctrl.iqxDate = moment(); $ctrl.closeDatePicker()  }
	}


	$ctrl.previousMoments = function(){
		var nextMoment = $ctrl.newMoment.clone()
		if(  $ctrl.datePicker.view==="yearSelect"  ){
			nextMoment.subtract(20, 'years')
			if(  !$ctrl.checkRangeIfDisabled(nextMoment, 'twentyYears')  ){  $ctrl.newMoment = nextMoment.clone(); $ctrl.yearSelectView($ctrl.newMoment)  }
		}else if($ctrl.datePicker.view=="monthSelect"){
			nextMoment.subtract(1, 'years')
			if(  !$ctrl.checkRangeIfDisabled(nextMoment, 'year')  ){  $ctrl.newMoment = nextMoment.clone(); $ctrl.monthSelectView($ctrl.newMoment)  }
		}else if(  $ctrl.datePicker.view=="daySelect"  ){  
			nextMoment.subtract(1, 'months')
			if(  !$ctrl.checkRangeIfDisabled(nextMoment, 'month')  ){  $ctrl.newMoment = nextMoment.clone(); $ctrl.daySelectView($ctrl.newMoment)  }
		}else if(  $ctrl.datePicker.view=="timeSelect"  ){
			nextMoment.subtract(1, 'days')
			if(  !$ctrl.checkRangeIfDisabled(nextMoment, 'day')  ){  $ctrl.newMoment = nextMoment.clone();   $ctrl.timeSelectView($ctrl.newMoment)  }
		}
	}

	$ctrl.futureMoments = function(){
		var nextMoment = $ctrl.newMoment.clone()
		if(  $ctrl.datePicker.view=="yearSelect"  ){
			nextMoment.add(20, 'years')
			if(  !$ctrl.checkRangeIfDisabled(nextMoment, 'twentyYears')  ){  $ctrl.newMoment = nextMoment.clone(); $ctrl.yearSelectView($ctrl.newMoment)  }
		}else if(  $ctrl.datePicker.view=="monthSelect"  ){
			nextMoment.add(1, 'years')
			if(  !$ctrl.checkRangeIfDisabled(nextMoment, 'year')  ){  $ctrl.newMoment = nextMoment.clone(); $ctrl.monthSelectView($ctrl.newMoment)  }
		}else if(  $ctrl.datePicker.view=="daySelect"  ){
			nextMoment.add(1, 'months')
			if(  !$ctrl.checkRangeIfDisabled(nextMoment, 'month')  ){  $ctrl.newMoment = nextMoment.clone();  $ctrl.daySelectView($ctrl.newMoment)  }
		}else if(  $ctrl.datePicker.view=="timeSelect"  ){
			nextMoment.add(1, 'days')
			if(  !$ctrl.checkRangeIfDisabled(nextMoment, 'day')  ){  $ctrl.newMoment = nextMoment.clone(); $ctrl.timeSelectView($ctrl.newMoment)  }
		}
	}
	
	$ctrl.viewUp = function(currentView){
		if(  currentView==="yearSelect"  ){  return  }
		else if(  currentView==="monthSelect"  ){  $ctrl.yearSelectView($ctrl.newMoment)  }
		else if(  currentView==="daySelect"  ){  $ctrl.monthSelectView($ctrl.newMoment)  }
		else if(  currentView==="timeSelect"  ){  $ctrl.daySelectView($ctrl.newMoment)  }
	}

	$ctrl.timeSelectView = function(){
		$ctrl.datePicker.view = "timeSelect"; $ctrl.datePicker.viewTitle = $ctrl.newMoment.format('ddd D MMM YYYY'); $ctrl.datePicker.timeSelect = $ctrl.datePicker.timeSelect || {}
		if(  !$ctrl.datePicker.timeSelect.momentTime  ){
			if(  moment.isMoment($ctrl.iqxDate)  ){  $ctrl.datePicker.timeSelect.momentTime = $ctrl.iqxDate.clone()  }
			else{  $ctrl.datePicker.timeSelect.momentTime = moment()  }
		}
		makeMomentTimeValid(); displayNewTime(); $ctrl.datePicker.show = true
	}

	$ctrl.daySelectView = function(){
		$ctrl.datePicker.view = "daySelect"; $ctrl.datePicker.viewTitle = $ctrl.newMoment.format('MMM YYYY'); $ctrl.datePicker.daySelect = {}
		
		if(!$ctrl.startWeekOnSunday){  // deal with starting week on monday/sunday...
			$ctrl.datePicker.daySelect.first = $ctrl.newMoment.clone().startOf('month').startOf('isoWeek')
			$ctrl.datePicker.daySelect.last = $ctrl.datePicker.daySelect.first.clone().add(41, 'days')
		}else{
			$ctrl.datePicker.daySelect.first = $ctrl.newMoment.clone().startOf('month').startOf('week')
			$ctrl.datePicker.daySelect.last = $ctrl.datePicker.daySelect.first.clone().add(41, 'days')
		}
		var days = [] // create list of days to go on calendar
		function addDay(momentObj){
			var newDay = {  momentObj:momentObj, disable:$ctrl.checkRangeIfDisabled(momentObj, "day"), isToday:momentObj.isSame(moment(), "day")  }
			days.push(newDay)
		}
		addDay($ctrl.datePicker.daySelect.first)
		while(days[days.length-1].momentObj.isBefore($ctrl.datePicker.daySelect.last, 'day')){
			addDay(days[days.length-1].momentObj.clone().add(1, "day"))
		}
		
		$ctrl.datePicker.daySelect.weeks = [] // create weeks
		angular.forEach(days, function(value, key) {
			if(  !$ctrl.datePicker.daySelect.weeks[Math.floor(key/7)]  ){  $ctrl.datePicker.daySelect.weeks[Math.floor(key/7)] = {}  } // create week object if it does not exist
			if(  !$ctrl.datePicker.daySelect.weeks[Math.floor(key/7)].days  ){  $ctrl.datePicker.daySelect.weeks[Math.floor(key/7)].days = []  } // create days array if it does not exist
			$ctrl.datePicker.daySelect.weeks[Math.floor(key/7)].days.push(value) // push new value into week
		})
		$ctrl.datePicker.show = true
	}
	
	$ctrl.monthSelectView = function(){
		$ctrl.datePicker.view = "monthSelect"; $ctrl.datePicker.viewTitle = $ctrl.newMoment.format('YYYY'); $ctrl.datePicker.monthSelect = {}; $ctrl.datePicker.monthSelect.months = []

		function addMonth(momentObj){
			var newMonth = {}
			newMonth.momentObj = momentObj
			newMonth.isThisMonth = momentObj.isSame(moment(), "month")
			newMonth.isDisabled = $ctrl.checkRangeIfDisabled(momentObj, "month")
			$ctrl.datePicker.monthSelect.months.push(newMonth)
		}

		addMonth($ctrl.newMoment.clone().startOf("year"))

		while($ctrl.datePicker.monthSelect.months.length < 12){
			addMonth($ctrl.datePicker.monthSelect.months[$ctrl.datePicker.monthSelect.months.length-1].momentObj.clone().add(1, "months"))
		}

		$ctrl.datePicker.show = true
	}

	$ctrl.yearSelectView = function(){
		$ctrl.datePicker.view = "yearSelect"; $ctrl.datePicker.yearSelect = {}; $ctrl.datePicker.yearSelect.years = []

		function addYear(momentObj){
			var newYear = {}
			newYear.momentObj = momentObj; newYear.isThisYear = momentObj.isSame(moment(), "year"); newYear.isDisabled = $ctrl.checkRangeIfDisabled(momentObj, "year")
			$ctrl.datePicker.yearSelect.years.push(newYear)
		}
		addYear($ctrl.newMoment.clone().subtract($ctrl.newMoment.year() % 20, "years")) // add first year on view
		while($ctrl.datePicker.yearSelect.years.length < 20){ // add the rest of the years for the view
			addYear($ctrl.datePicker.yearSelect.years[$ctrl.datePicker.yearSelect.years.length-1].momentObj.clone().add(1, "years")) // keep adding years until we have 20
		}
		$ctrl.datePicker.viewTitle = $ctrl.datePicker.yearSelect.years[0].momentObj.format('YYYY') + " - " + $ctrl.datePicker.yearSelect.years[19].momentObj.format('YYYY')
		$ctrl.datePicker.show = true
	}


	$ctrl.timeJsUpdate = function(){
		if($ctrl.datePicker.timeSelect.jsTime){$ctrl.datePicker.timeSelect.momentTime = moment($ctrl.datePicker.timeSelect.jsTime).seconds(0).milliseconds(0)}
		else{$ctrl.datePicker.timeSelect.momentTime = moment()}
		makeMomentTimeValid();	displayNewTime()
	}

	$ctrl.timePickerUpdate = function(){
		var hours = Math.round(Number($ctrl.datePicker.timeSelect.hours)), minutes = Math.round(Number($ctrl.datePicker.timeSelect.minutes))
		if(  hours !== NaN  ){  $ctrl.datePicker.timeSelect.momentTime.hours(hours)  } // if hours/minutes is not a number then the moment obj is not updated with them
		if(  minutes !== NaN  ){  $ctrl.datePicker.timeSelect.momentTime.minutes(minutes).seconds(0).milliseconds(0)  }
		makeMomentTimeValid(); displayNewTime() // ensure that time is within range. display time and set js time.
	}

	var makeMomentTimeValid = function(){
		// must do checks with newMoment, setting hours and minutes, as a time today may be valid, but the same time tommorow might not...
		if($ctrl.datePicker.min && $ctrl.newMoment.hours($ctrl.datePicker.timeSelect.momentTime.hours()).minutes($ctrl.datePicker.timeSelect.momentTime.minutes()).isBefore($ctrl.datePicker.min)){
			$ctrl.datePicker.timeSelect.momentTime = $ctrl.datePicker.min.clone().seconds(0).milliseconds(0)
		}
		if($ctrl.datePicker.max && $ctrl.newMoment.hours($ctrl.datePicker.timeSelect.momentTime.hours()).minutes($ctrl.datePicker.timeSelect.momentTime.minutes()).isAfter($ctrl.datePicker.max)){
			$ctrl.datePicker.timeSelect.momentTime = $ctrl.datePicker.max.clone().seconds(0).milliseconds(0)
		}
		$ctrl.datePicker.timeSelect.momentTime.seconds(0).milliseconds(0)
	}

	var displayNewTime = function(){
		$ctrl.datePicker.timeSelect.jsTime = ($ctrl.datePicker.timeSelect.momentTime.toDate()) // set jsTime to momentTime (clearing seconds and milliseconds)
		if(  $ctrl.datePicker.timeSelect.momentTime.hours() <10  ){  $ctrl.datePicker.timeSelect.hours = "0" + $ctrl.datePicker.timeSelect.momentTime.hours()  }
		else{  $ctrl.datePicker.timeSelect.hours = $ctrl.datePicker.timeSelect.momentTime.hours()  }
		if(  $ctrl.datePicker.timeSelect.momentTime.minutes() <10  ){  $ctrl.datePicker.timeSelect.minutes = "0" + $ctrl.datePicker.timeSelect.momentTime.minutes()  }
		else{  $ctrl.datePicker.timeSelect.minutes = $ctrl.datePicker.timeSelect.momentTime.minutes()  }
	}

	// time add/subtract functions, adds/subtracts time, makes time valid and then displays the time
	$ctrl.addMinute = function(){  $ctrl.datePicker.timeSelect.momentTime.add(1, "minutes"); makeMomentTimeValid(); displayNewTime()  }
	$ctrl.subtractMinute = function(){  $ctrl.datePicker.timeSelect.momentTime.subtract(1, "minutes"); makeMomentTimeValid(); displayNewTime()  }
	$ctrl.addHour = function(){  $ctrl.datePicker.timeSelect.momentTime.add(1, "hours"); makeMomentTimeValid(); displayNewTime()  }
	$ctrl.subtractHour = function(){  $ctrl.datePicker.timeSelect.momentTime.subtract(1, "hours"); makeMomentTimeValid(); displayNewTime()  }

	$ctrl.timeSelect = function(){
		if(!$ctrl.datePicker.timeSelect.momentTime){
			alert("Please select a time") // dont think it is possible for it to be empty, but just in case
		}else{
			$ctrl.iqxDate = $ctrl.newMoment.hours($ctrl.datePicker.timeSelect.momentTime.hours()).minutes($ctrl.datePicker.timeSelect.momentTime.minutes())
			$ctrl.closeDatePicker()
		}
	}
	$ctrl.daySelect = function(day){
		if(  day.disable  ){  return  }
		else if(  $ctrl.accuracy=="day"  ){  $ctrl.iqxDate = day.momentObj.clone(); $ctrl.datePicker.daySelect = {}; $ctrl.closeDatePicker()  } // set iqxDate, close date picker
		else{  $ctrl.newMoment = day.momentObj.clone(); $ctrl.datePicker.daySelect = {}; $ctrl.timeSelectView()  } // set newMoment, open time select view
	}
	$ctrl.monthSelect = function(month){
		if(  month.isDisabled  ){  return  }
		else if(  $ctrl.accuracy=="month"  ){  $ctrl.iqxDate = month.momentObj.clone(); $ctrl.closeDatePicker()  }
		else{  $ctrl.newMoment = month.momentObj.clone();  $ctrl.daySelectView()  }
	}
	$ctrl.yearSelect = function(year){
		if(  year.isDisabled  ){  return  }
		else if(  $ctrl.accuracy=="year"  ){  $ctrl.iqxDate = year.momentObj.clone(); $ctrl.closeDatePicker()  }
		else{  $ctrl.newMoment = year.momentObj.clone(); $ctrl.monthSelectView()  }
	}
})